const API = {
    URL: "https://site.pandhora.com/api",
};

export default API;